var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmSuspend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33133 11.5613C8.33133 11.2185 8.36355 10.8793 8.42622 10.5475L12.1287 14.25L7.37868 19H6.94423C6.69889 19 6.5 18.7921 6.5 18.5356C6.5 18.2791 6.69889 18.0711 6.94423 18.0711C7.32426 18.0711 7.59131 17.936 7.89867 17.6362C8.17975 17.362 8.33133 16.9972 8.33133 16.6242V11.5613ZM9.87142 7.7501L14.25 12.1287L18.3654 8.01326C18.2497 7.8762 18.1269 7.74416 17.9973 7.61771C17.1728 6.81333 16.1245 6.28486 15 6.08719V5.5C15 4.94772 14.5523 4.5 14 4.5C13.4477 4.5 13 4.94772 13 5.5V6.08718C11.8755 6.28485 10.8272 6.81332 10.0027 7.61771C9.95812 7.66119 9.91436 7.70533 9.87142 7.7501ZM11.6213 19L14.25 16.3713L16.8787 19H11.6213ZM16.3713 14.25L21.117 18.9956C21.3333 18.9645 21.5 18.7704 21.5 18.5356C21.5 18.2791 21.3011 18.0711 21.0558 18.0711C20.6757 18.0711 20.4086 17.936 20.1013 17.6362C19.8202 17.362 19.6686 16.9972 19.6686 16.6242V11.5613C19.6686 11.3673 19.6583 11.1744 19.638 10.9833L16.3713 14.25ZM12.5 20.75C12.0858 20.75 11.75 21.0858 11.75 21.5C11.75 21.9142 12.0858 22.25 12.5 22.25H15.5C15.9142 22.25 16.25 21.9142 16.25 21.5C16.25 21.0858 15.9142 20.75 15.5 20.75H12.5Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 22.25L22.25 6.25",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 22.25L6.25 6.25",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmSuspend);
export default __webpack_public_path__ + "static/media/ic-alarm-suspend.73cf6adbfde6d7a5427ce44d52d2f381.svg";
export { ForwardRef as ReactComponent };